import React, {Component} from 'react';
import './Navigation.css';
import Tile, {TILES} from "./Tile";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import {
  MODEL_CUSTOMERS, MODEL_PROJECTS,
  MODEL_SERVICES,
  Models
} from "../reducers/drfConnector";
import * as actions from "../actions/actions";
import {connect} from 'react-redux';
import { withRouter } from "react-router";

class Navigation extends Component {
  constructor(props) {
    super(props);
    this.props = props;
  }

  componentDidMount(){
    // check for new server data every hour
    const refreshDate = new Date(new Date() - (60*60*1000));
    const lastUpdateCheck = new Date(Date.parse(this.props.lastUpdateCheck));
    if (!this.props.lastUpdateCheck) {
      [MODEL_CUSTOMERS, MODEL_SERVICES, MODEL_PROJECTS]
        .filter(model => Object.keys(this.props.models[model]).length === 0)
        .forEach(model => {
          this.props.fetchList(model);
        });
    }
    if(!this.props.lastUpdateCheck || lastUpdateCheck.getTime() < refreshDate.getTime()){
      this.props.fetchUpdates();
    }
  }

  componentWillReceiveProps(nextProps){
    // if there was an update on the server
    if(nextProps.lastUpdate !== this.props.lastUpdate){
      // check which lists have changed
      let interval = 10000;
      for(const list of Models){
        setTimeout(() => {this.props.fetchList(list)}, interval);
        interval += 2000;
      }
    }
  }

  getFeatureTile(timeouts) {
    return <CSSTransition key={this.props.selectedTile} classNames="nav" appear={true} enter={true} exit={true} timeout={timeouts}>
      <Tile key={this.props.selectedTile} name={this.props.selectedTile}/>
    </CSSTransition>;
  }

  getTileCluster(intro, div, enter, exit, timeouts) {
    return Object.keys(TILES).map((tile) => {
      if(tile !== this.props.selectedTile){
        return <CSSTransition key={tile} classNames={div} appear={true} enter={enter} exit={exit} timeout={timeouts}>
          <Tile intro={intro} name={tile} minified={(this.props.selectedTile)} />
        </CSSTransition>;
      }
      return null;
    });
  }

  getIntro() {
    return <div id="intro"><TransitionGroup>
      {this.getTileCluster(true, "intro", false, false,
        {appear: 1000, exit: 500})}
    </TransitionGroup>
    </div>;
  }

  getMainNav() {
    return <div id="main-nav"><TransitionGroup>
      {this.getFeatureTile({appear: 300, enter: 300, exit: 500})}
      {this.getTileCluster(false, "nav", true, true, {appear: 300, enter: 300, exit: 500})}
    </TransitionGroup>
    </div>;
  }

  render() {
    return (this.props.selectedTile) ? this.getMainNav():this.getIntro();
  }
}

const mapStateToProps = (state, props) => {
  return {
    ...props,
    lastUpdate: state.drf.lastUpdate,
    lastUpdateCheck: state.drf.lastUpdateCheck,
    models: state.drf.models,
  }
};

const NavigationWithRouter = withRouter(connect(
  mapStateToProps,
  actions
)(Navigation));

export default NavigationWithRouter;



// WEBPACK FOOTER //
// ./src/components/Navigation.js